// Client for the ServiceNow incident endpoints served by backend-node-v2. Base URL =
// EnvironmentConfig.nodeService. Auth = MSAL JWT (same Bearer token the rest of the app uses,
// e.g. dashboardApi.ts / setShareData.tsx) — no kid, no x-proxy/x-proxy-token.
import { EnvironmentConfig } from "@me8eon/config";

type TokenFn = () => Promise<string | undefined>;

const BASE = `${EnvironmentConfig.nodeService}/service/incidents`;

export type CreateIncidentPayload = {
    contact_number: string;
    service?: string;
    short_description: string;
    description: string;
    external_ticket_id?: string;
    category?: string;
    sub_category?: string;
    contact_type?: string;
    location_id?: string;
    configuration_item?: string;
    assignment_group: string;
    file_name?: string;
    file_data?: string;
};

export type CreateIncidentResult = {
    number: string;
    message: string;
};

export async function createIncident(payload: CreateIncidentPayload, token: TokenFn): Promise<CreateIncidentResult> {
    const res = await fetch(BASE, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${await token()}` },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(`incidents/create failed: ${res.status}`);
    const body = await res.json();
    return body?.result;
}

export type ListIncidentsResponse = {
    result: {
        queryResult: Record<string, unknown>[];
        message: string;
    };
};

export async function listIncidents(isActive: boolean, token: TokenFn): Promise<ListIncidentsResponse> {
    const res = await fetch(`${BASE}?isActive=${isActive}`, {
        headers: { Authorization: `Bearer ${await token()}` },
    });
    if (!res.ok) throw new Error(`incidents/list failed: ${res.status}`);
    return res.json();
}
